import React from 'react';
import { motion } from 'framer-motion';
import { Package, Sparkles } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

const ProductsHeader: React.FC = () => {
  const { t } = useTranslation('products');
  return (
    <motion.div
      className="mb-12 text-center sm:text-left"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="inline-flex items-center gap-3 mb-4">
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 rounded-2xl blur-lg opacity-50" />
          <div className="relative p-3 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl shadow-lg">
            <Package className="w-8 h-8 text-white" />
          </div>
        </div>
        <div>
          <h1 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 dark:from-white dark:via-gray-100 dark:to-white bg-clip-text text-transparent">
            {t('title')}
          </h1>
          <div className="flex items-center gap-2 mt-2">
            <Sparkles className="w-4 h-4 text-indigo-500" />
            <p className="text-sm font-medium text-indigo-600 dark:text-indigo-400">
              {t('subtitle')}
            </p>
          </div>
        </div>
      </div>
      <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mt-4 leading-relaxed">
        {t('description')}
      </p>
    </motion.div>
  );
};

export default ProductsHeader;

